import React from "react";
import styled from "styled-components";

import { Box } from '@mui/material';
import { ChevronRight, Sort, Add } from "@mui/icons-material";
import TooltipIconButton from "components/TooltipIconButton";

const Wrapper = styled.summary`
  position: relative;
  padding: 0rem 2.5rem;
  height: 50px;
  align-items: center;
  background: ${({ theme }) => theme.backgroundColor.accordion.header};
  border-top: 1px solid ${({ theme }) => theme.border.accordion};
  border-bottom: 1px solid ${({ theme }) => theme.border.accordion};
  display: flex;
  &::marker {
    content: none;
  }
  &::-webkit-details-marker {
    display: none;
  }
  h2 {
    width: calc(100% - 2rem);
    font-size: 14px;
    font-weight: bold;
  }
  &:focus {
    outline: 0;
  }
  &:hover {
    cursor: pointer;
  }
`;

const ColorIndicator = styled.div`
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  background-color: ${props => props.color ? props.color + " !important" : ""};
  border-radius: 30px;
  margin-right: 10px;
`;

const Summary = ({ heading, sort, add, onAdd, id, color, file }) => {


  const collapseAccordion = () => {
    document.getElementById(id).click();
  }

  const onFileChange = event => {

    // Update the state
    onAdd(event.target.files[0]);

  };

  const uploadAddStyle = {
    marginRight: '11px',
    marginTop: '5px'
  }
  return (
    <Wrapper id={id}>
      <h2>{heading}</h2>
      <Box display="flex" alignItems="center">
        {color && <ColorIndicator color={color} />}
        {add && file &&
          <>
            <label htmlFor="btn-upload">
              <input
                id="btn-upload"
                name="btn-upload"
                style={{ display: 'none' }}
                type="file"
                onChange={onFileChange} />
              <Add fontSize="large" style={uploadAddStyle} />

            </label>
          </>
        }
        {add && !file &&
          <TooltipIconButton title="Add" ariaLabel="add" placement="top" size={44} onClick={onAdd} >
            <Add fontSize="large" />
          </TooltipIconButton>
        }
        {sort &&
          <TooltipIconButton title="Sort" ariaLabel="sort" placement="top" size={44}>
            <Sort fontSize="large" />
          </TooltipIconButton>
        }
        <TooltipIconButton title="Collapse" ariaLabel="collapse" placement="top" size={44} onClick={collapseAccordion}>
          <ChevronRight fontSize="large" className="chevron-right" />
        </TooltipIconButton>
      </Box>
    </Wrapper>
  )
};

export default Summary;
